import * as form from '../form';

export const legalAssociationsInternationalAndDomesticTerrorism = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Organization: form.text(xitem.Organization),
        HasUSAddress: form.branch(xitem.HasUSAddress),
        USAddress: form.location(xitem.USAddress),
        HasForeignAddress: form.branch(xitem.HasForeignAddress),
        ForeignAddress: form.location(xitem.ForeignAddress),
        HasWebpage: form.branch(xitem.HasWebpage),
        Webpage: form.text(xitem.Webpage),
        Dates: form.daterange(xitem.Dates),
        ReasonsForStaying: form.textarea(xitem.ReasonsForStaying),
        ReasonsForLeaving: form.textarea(xitem.ReasonsForLeaving),
        HeldPositions: form.branch(xitem.HeldPositions),
        PositionsHeld: form.text(xitem.PositionsHeld),
        HasMadeContributions: form.branch(xitem.HasMadeContributions),
        ContributionAmount: form.text(xitem.ContributionAmount),
        WasAwareOfViolence: form.branch(xitem.WasAwareOfViolence),
        WasAwareOfViolenceExplaination: form.textarea(xitem.WasAwareOfViolenceExplaination),
        IntendedViolence: form.branch(xitem.IntendedViolence),
        IntendedViolenceExplaination: form.textarea(xitem.IntendedViolenceExplaination),
        DidUseViolence: form.branch(xitem.DidUseViolence),
        UseOfViolenceExplaination: form.textarea(xitem.UseOfViolenceExplaination),
        ReasonForJoining: form.textarea(xitem.ReasonForJoining),
        RoleInOrg: form.textarea(xitem.RoleInOrg),
      },
    };
  });
  return {
    HasInternationalAndDomesticTerrorism: form.branch(data.HasInternationalAndDomesticTerrorism),
    List: form.collection(items, (data.List || {}).branch),
  };
};
